import React from 'react'
import { Button, Typography, icons, theme } from 'cdh-data-portal-theme'
import type { useStyles } from '../DataGovernorsPage.style'
import { localText } from '../DataGovernorsPage.static'
import { assignmentSummaryText } from './RegistrySummary.static'

export interface RegistrySummaryProps {
  readonly classes: ReturnType<typeof useStyles>['classes']
  readonly assignmentCount: number
  readonly hubCount: number
  readonly onAddGovernor: () => void
}

export const RegistrySummary: React.FC<RegistrySummaryProps> = ({
  classes,
  assignmentCount,
  hubCount,
  onAddGovernor,
}) => (
  <div className={classes.summaryRow}>
    <Typography variant="body" color={theme.textColors.primaryLighter}>
      {assignmentSummaryText(assignmentCount, hubCount)}
    </Typography>
    <Button icon={icons.add} onClick={onAddGovernor} title={localText.addGovernorButton} variant="primary" />
  </div>
)
